import Logo from "./Logo";
import github from "../../asset/images/svgs/github-icon.svg"
import linkedin from "../../asset/images/svgs/linkedin-icon.svg"
import icon_saprator from  "../../asset/images/icon_saprator_header.png"
import React from "react";


export default function Header() {
    const handleClickScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    };
    return (
            <header>
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-md navbar-dark fixed-top">
                        <div className={"container"}>
                            <Logo/>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarCollapse" aria-controls="navbarCollapse"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse header_nav"
                                 id="navbarCollapse">
                                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                                    <li className="nav-item cursor-pointer"  onClick={()=>handleClickScroll("project")}>
                                        <a className="nav-link active" aria-current="page" href="#projects">Projects</a>
                                    </li>
                                    <li className="nav-item" onClick={()=>handleClickScroll("technologies")}>
                                        <a className="nav-link active" aria-current="page" href="#technologies">Technologies</a>
                                    </li>
                                    <li className="nav-item" onClick={()=>handleClickScroll("get-in-touch")}>
                                        <a className="nav-link active" aria-current="page" href="#get-in-touch">Get-In-Touch</a>
                                    </li>
                                </ul>
                                <ul className={""}>
                                    <li>
                                        <a className={"mx-3 first_nav_icon"} href="https://github.com/BrijeshLathiya" target="_blank">
                                            <img src={github} alt="Brijesh github"/>
                                        </a>
                                        <img src={icon_saprator} alt="Brijesh portfolio design"/>
                                        <a className={"mx-3 linked_icon_main"} href="https://www.linkedin.com/in/brijesh-l-000372200" target="_blank">
                                            <img src={linkedin} alt="Brijesh linkedin"/>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
    )
}